import React, { useState, useEffect } from "react";
import { useParams, Link  } from "react-router-dom";
import { FaRegNewspaper, FaRegCalendarAlt } from "react-icons/fa";
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaWhatsapp, FaTelegramPlane } from "react-icons/fa";
import "../NewsArticle.scss";
import Header from "../components/Header";
import Footer from "../components/Footer";

const NewsArticle = () => {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [recentPosts, setRecentPosts] = useState([]);
  const [archives, setArchives] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);



  useEffect(() => {
    fetchArticle();
    fetchSidebarData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug]);

  const fetchArticle = async () => {
    try {
      const response = await fetch(`/php-api/get_articles.php?slug=${encodeURIComponent(slug)}`);
      const data = await response.json();
      if (data.success) setArticle(data.article);
      else setError("Article not found");
    } catch {
      setError("Failed to load article");
    } finally {
      setLoading(false);
    }
  };

  const fetchSidebarData = async () => {
    try {
      const response = await fetch("/php-api/getarticlelisting.php");
      const data = await response.json();
      if (data.success) {
        setRecentPosts(data.articles.slice(0, 5));
        const monthsSet = new Set();
        data.articles.forEach((art) => {
          const d = new Date(art.publishDate);
          const month = d.toLocaleString("default", { month: "long" }).toLowerCase();
          const year = d.getFullYear();
          monthsSet.add(`${month}-${year}`);
        });
        const sortedMonths = Array.from(monthsSet).sort((a, b) => {
          const [monthA, yearA] = a.split("-");
          const [monthB, yearB] = b.split("-");
          return new Date(`${yearB}-${monthB}-01`) - new Date(`${yearA}-${monthA}-01`);
        });
        setArchives(sortedMonths);
      }
    } catch (err) {
      console.error("Failed to load sidebar data", err);
    }
  };

  const currentUrl = window.location.href;

  if (loading) return <div className="loading">Loading article...</div>;
  if (error) return <div className="error">{error}</div>;
  if (!article) return <div className="error">No article data</div>;

  return (
    <>
      <Header />
      <div className="page-body-container">
        <div className="news-article-page">
        <div className="content-area">
          <div className="news-article-container">
              <h1 className="article-title">{article.title}</h1>
            <article className="news-article">
                   {article.image_url && (
                <div className="featured-image">
                  <img src={article.image_url} alt={article.title} />
                </div>
              )}
            

              <div className="article-meta">
               
                      <span className="publish-date">Published: {new Date(article.publishDate).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  })}
</span>
                {/* <span className="publish-date">Published: {article.publishDate}</span> */}
                {article.category && <span className="category">Category: {article.category}</span>}
              </div>

              {/* Social Share Icons */}
              <p><b>Share this</b></p>
              <div className="social-share">
                <a
                  href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon facebook"
                >
                  <FaFacebookF />
                </a>
                <a
                  href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(currentUrl)}&text=${encodeURIComponent(article.title)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon twitter"
                >
                  <FaTwitter />
                </a>
                <a
                  href={`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(currentUrl)}&title=${encodeURIComponent(article.title)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon linkedin"
                >
                  <FaLinkedinIn />
                </a>
                <a
                  href={`https://api.whatsapp.com/send?text=${encodeURIComponent(article.title + " " + currentUrl)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon whatsapp"
                >
                  <FaWhatsapp />
                </a>
                <a
                  href={`https://t.me/share/url?url=${encodeURIComponent(currentUrl)}&text=${encodeURIComponent(article.title)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon telegram"
                >
                  <FaTelegramPlane />
                </a>
              
              </div>

         

              <div className="article-content" dangerouslySetInnerHTML={{ __html: article.content }} />

              {/* {article.tags && article.tags.length > 0 && (
                <div className="article-tags">
                  <span>Tags: </span>
                  {article.tags.map((tag, idx) => (
                    <Link key={idx} to={`/news/tag/${tag.toLowerCase()}`}>
                      {tag}
                    </Link>
                  ))}
                </div>
              )} */}
              {article.tags && (
  <div className="article-tags">
    <span>Tags: </span>
    {(
      Array.isArray(article.tags)
        ? article.tags
        : article.tags.split(",").map(tag => tag.trim()) // convert string → array
    ).map((tag, idx) => (
      // <Link key={idx} to={`/news/tag/${tag.toLowerCase()}`}>
      //   {tag}
      // </Link>
      <Link
  key={idx}
  to={`/news?tag=${encodeURIComponent(tag.toLowerCase())}`}
> {tag}</Link>
    ))}
  </div>
)}
            </article>
          </div>

          {/* Sidebar */}
      <aside className="sidebar">
  <div className="sidebar-section recent-posts">
    <h3>Recent News</h3>
    <ul>
      {recentPosts.map((post) => (
        <li key={post.id} className="post-item">
          <Link to={`/news/${post.slug}`} className="post-link">
            <FaRegNewspaper className="post-icon" />
            <span>{post.title}</span>
          </Link>
        </li>
      ))}
    </ul>
  </div>

  <div className="sidebar-section archives">
    <h3>Archives</h3>
    <ul>
      {archives.map((monthSlug, idx) => {
        const [month, year] = monthSlug.split("-");
        const display = `${month.charAt(0).toUpperCase() + month.slice(1)} ${year}`;
        return (
          <li key={idx} className="archive-item">
            <Link to={`/news/archive/${monthSlug}`} className="archive-link">
              <FaRegCalendarAlt className="archive-icon" />
              <span>{display}</span>
            </Link>
          </li>
        );
      })}
    </ul>
  </div>
</aside>
        </div>
      </div>
      <Footer />
      </div>
    </>
  );
};

export default NewsArticle;
